import React from 'react'
import tcencoIcon from 'images/payments/t-cenco.svg'
import NewTcIcon from 'images/payments/new-tc-icon.svg';
import { HtmlParse } from 'utils/index';
import useVariant from 'hooks/useVariant';
import style from './style.scss';//NOSONAR

const IconCencosudCard = ({className}) => {
    const variant = useVariant('ktwmU0ZSQh2SlmPpCUQ6rg');
    const image = variant === '1' ? NewTcIcon : tcencoIcon;

    return <i className={'icon-tcenco ' + (className || '')} alt="Cencosud">{HtmlParse(image)}</i>
}

export default IconCencosudCard;
